import React, { useEffect, useState } from "react";

import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import InputDate from "../../../components/InputDate";
import InputSelect from "../../../components/InputSelect";
import SelectCompany from "../../../components/selects/SelectCompany";

import { getBillingCompanyLabel } from "../../Finance/billingCompany";
import { LINK_OPTIONS, PAYMENT_OPTIONS } from "../helpers";

// Filtros da lista de notas de entrada: estado local hidratado da URL ao
// abrir, "Aplicar"/"Limpar" devolvem para a lista (padrão Product/ModalFilter).
export const ModalFilter = ({ show, close, filters, setCustomFilters, billingCompanies = [] }) => {
    const [issuedFrom, setIssuedFrom] = useState('');
    const [issuedTo, setIssuedTo] = useState('');
    const [companyId, setCompanyId] = useState(null);
    const [billingCompanyId, setBillingCompanyId] = useState('');
    const [link, setLink] = useState('');
    const [payment, setPayment] = useState('');

    useEffect(() => {
        if (!show) return;

        setIssuedFrom(filters.issuedFrom);
        setIssuedTo(filters.issuedTo);
        setCompanyId(filters.companyId || null);
        setBillingCompanyId(filters.billingCompanyId);
        setLink(filters.link);
        setPayment(filters.payment);
    }, [show, filters]);

    const apply = () => {
        setCustomFilters({
            issuedFrom,
            issuedTo,
            companyId: companyId || '',
            billingCompanyId,
            link,
            payment,
        });
        close();
    };

    const clear = () => {
        setCustomFilters({
            issuedFrom: '',
            issuedTo: '',
            companyId: '',
            billingCompanyId: '',
            link: '',
            payment: '',
        });
        close();
    };

    return (
        <Modal
            title={`Filtrar notas de entrada`}
            show={show}
            close={close}
            footer={
                <>
                    <Button type={`secondary`} size={`small`} text={`Limpar filtros`} action={clear} />
                    <Button type={`primary`} size={`small`} text={`Aplicar`} action={apply} />
                </>
            }
        >
            <div className="section">
                <div className="row">
                    <div className="col-6">
                        <InputDate label={`Emissão de`} format={`YYYY-MM-DD`} value={issuedFrom} change={setIssuedFrom} />
                    </div>
                    <div className="col-6">
                        <InputDate label={`Emissão até`} format={`YYYY-MM-DD`} value={issuedTo} change={setIssuedTo} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <SelectCompany
                            label={`Fornecedor`}
                            nullable={true}
                            selectedCompany={companyId}
                            setSelectedCompany={setCompanyId}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <InputSelect menuInBody label={`Compra vinculada`} options={LINK_OPTIONS} value={link} change={setLink} />
                    </div>
                    <div className="col-6">
                        <InputSelect menuInBody label={`Conta a pagar`} options={PAYMENT_OPTIONS} value={payment} change={setPayment} />
                    </div>
                </div>
                {billingCompanies.length > 1 &&
                    <div className="row">
                        <div className="col-12">
                            <InputSelect
                                menuInBody
                                label={`Empresa que recebeu`}
                                options={[
                                    { label: 'Todas', value: '' },
                                    ...billingCompanies.map(company => ({
                                        label: getBillingCompanyLabel(company),
                                        value: company.id,
                                    })),
                                ]}
                                value={billingCompanyId}
                                change={setBillingCompanyId}
                            />
                        </div>
                    </div>
                }
            </div>
        </Modal>
    );
};

export default ModalFilter;
